import { SetState, GetState } from 'zustand';
import { IBillItem } from '../../../types';
import { removeDuplicateBillsByBillId, updateItemByExternalId, updateNewItemByExternalId } from '../utils';

export interface IUnpaidBillsSlice {
  totalUnPaidBills: number;
  setTotalUnPaidBills: (payload: number) => void;
  unpaidBills: Array<IBillItem> | [];
  setUnpaidBills: (bills: Array<IBillItem> | [], shouldConcat: boolean) => void;
  unpaidBillsPageNumber: number;
  setUnpaidBillsPageNumber: (payload: number) => void;
  incrementUnpaidBillsPageNumber: () => void;
  setUpdatedUnpaidBillById: (billId: string, docId:string) => void;
  updateNewItemByExternalId: (billItem: IBillItem) => void;
  resetUnpaidBillsSlice: () => void;
}

const unpaidBillsInitialState = {
  unpaidBills: [],
  unpaidBillsPageNumber: 0,
  totalUnPaidBills: 0,
};

const createUnpaidBillsSlice = (set: SetState<IUnpaidBillsSlice>, get: GetState<IUnpaidBillsSlice>) => ({
  unpaidBills: [],
  setUnpaidBills: (bills: Array<IBillItem>, shouldConcat: boolean) => {
    if (!shouldConcat) set({ unpaidBills: removeDuplicateBillsByBillId(bills) });
    else set((prevState) => ({ unpaidBills: removeDuplicateBillsByBillId([...prevState.unpaidBills, ...bills]) }));
  },
  setUpdatedUnpaidBillById: (billId: string, docId: string) => {
    const bills = updateItemByExternalId(get().unpaidBills, billId, docId);
    set({ unpaidBills: bills });
  },
  updateNewItemByExternalId: (billItem: IBillItem) => {
    const bills = updateNewItemByExternalId(get().unpaidBills, billItem);
    set({ unpaidBills: bills });
  },
  incrementUnpaidBillsPageNumber: () => set((prevState) => ({ unpaidBillsPageNumber: prevState.unpaidBillsPageNumber + 1 })),
  unpaidBillsPageNumber: 0,
  setUnpaidBillsPageNumber: (payload: number) => {
    set({ unpaidBillsPageNumber: payload });
  },
  resetUnpaidBillsSlice: () => {
    set(unpaidBillsInitialState);
  },
  totalUnPaidBills: 0,
  setTotalUnPaidBills: (payload: number) => {
    set({ totalUnPaidBills: payload });
  },
});

export default createUnpaidBillsSlice;
